import { render, staticRenderFns } from "./InvoiceDetailsRejected.vue?vue&type=template&id=578580de&scoped=true&"
import script from "./InvoiceDetailsRejected.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsRejected.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsRejected.vue?vue&type=style&index=0&id=578580de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578580de",
  null
  
)

export default component.exports